import { useEffect } from 'react';
import { useManagement } from '../hooks/management';
import DefaultFallback from './DefaultFallback';
import { useSession } from '../Context';

const Authenticating = ({ fallback, setState }) => {
  const { setSession } = useSession();
  const { checkAuthorization } = useManagement();
  useEffect(() => {
    checkAuthorization().then((session) => {
      if (session) {
        setSession(session);
        setState('AUTHENTICATED');
      } else {
        setState('UNAUTHENTICATED');
      }
    });
  }, [setState, setSession, checkAuthorization]);
  return fallback || <DefaultFallback />;
};

export default Authenticating;
